// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__prM8g","title":"ClientCherryInfo_title__22i8K","itemText":"ClientCherryInfo_itemText__2gvSG"};